import React from 'react';

const Footer = () => {
	return (
		<div className='App-footer'>
			Developed by{' '}
			<a href='https://www.linkedin.com/in/kristina-andersson/'>
				Kristina Andersson
			</a>{' '}
			for{' '}
			<a href='http://www.medieteknik.com/namnder/naringslivsgruppen'>NLG</a>,{' '}
			<a href='https://www.kth.se/'>KTH</a>.{'   '}Photo by{' '}
			<a href='https://unsplash.com/@photohunter'>Jimmy Chang</a>.
		</div>
	);
};

export default Footer;
